// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ActionRequired a,.ActionRequired button{padding-left:24px;padding-right:24px;padding-top:16px;padding-bottom:16px;font-size:14px}.title-beta{top:-7px}", ""]);
// Exports
module.exports = exports;
